import { FormControl } from "@angular/forms";

export class CustomValidators {
    nameValidator(control: FormControl): { [key: string]: boolean } | undefined {
        const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if (control.value && nameRegexp.test(control.value)) {
           return { invalidName: true };
        }
        return undefined;
    }
}